export const UPI_DOWNTIME_MANAGEMENT_PAGE_NAME = 'getUPIDowntimeManagementPage';
export const FORM_MODE = 'edit';

export enum DowntimeManagementConstants {
	GET_CONFIG_URI = '/dashboard/getDowntimeManagementConfig/downtimeManagement-upi-getUPIDowntimeManagementPage',
	UPDATE_CONFIG_URI = '/dashboard/updateDowntimeManagementConfig/downtimeManagement-upi-getUPIDowntimeManagementPage'
}
